import MinuteGift from '@/api/minute_gift'
import loading from '../helpers/loading'

export default {
  namespaced: true,
  state: {
    ...loading.state
  },
  getters: {
    ...loading.getters
  },
  mutations: {
    ...loading.mutations
  },
  actions: {
    create: ({ commit }, { user_id, card_id, minutes, reason }) => {
      commit('changeLoading', { isLoading: true })
      return MinuteGift.create({
        user_id,
        card_id,
        minutes,
        reason
      })
        .then(({ data }) => {
          commit('changeLoading', { isLoading: false })
          commit('skiliko/users/updateItem', { item: data.user }, { root: true })
          return data
        })
        .catch(error => {
          commit('changeLoading', { isLoading: false })
          throw error
        })
    },
    update: ({ commit }, { id }) => {
      commit('changeLoading', { isLoading: true })
      return MinuteGift.update({ id })
        .then(({ data }) => {
          commit('changeLoading', { isLoading: false })
          commit('skiliko/users/updateItem', { item: data.user }, { root: true })
          return data
        })
        .catch(error => {
          commit('changeLoading', { isLoading: false })
          throw error
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/minute_gifts/index.js